import { forwardRef } from 'react'

import { Menu } from 'antd'
import type { MenuProps, MenuRef } from 'antd'

const DarkMenu = forwardRef<MenuRef, MenuProps>((props, ref) => (
    <Menu {...props} ref={ref} theme="dark" />
))

DarkMenu.displayName = 'DarkMenu'

export default DarkMenu
